<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin"
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.product"
                dense
                :disabled="type == 'edit'"
                :items="['cso']"
                item-text="name"
                item-value="id"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
                @change="tenantList"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant_id"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsCSO
                    : []
                "
                :disabled="type == 'edit'"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.location_ids"
                dense
                :disabled="readOnly"
                :items="locationsList"
                item-value="id"
                item-text="name"
                :label="$t('select_location_*')"
                multiple
                clearable
                :rules="[rules.multi_select_required]"
                @change="onLocationChange"
              >
                <!-- :rules="[rules.required]" -->
                <template v-slot:selection="data">
                  <span
                    v-if="data.index === 0"
                    class="selected"
                  >
                    <span>{{ data.item.name }}</span>
                  </span>
                  <span
                    v-if="data.index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ options?.location_ids?.length - 1 }} others)
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.charge_stations"
                dense
                :disabled="readOnly"
                :items="
                  options.location_ids && options.location_ids.length > 0
                    ? chargersList
                    : []
                "
                item-value="charge_station_id"
                item-text="charge_point_id"
                :label="$t('charge_point_id_*')"
                multiple
                clearable
                :rules="[rules.multi_select_required]"
              >
                <template v-slot:selection="data">
                  <span
                    v-if="data.index === 0"
                    class="selected"
                  >
                    <span>{{ data.item.charge_point_id }}</span>
                  </span>
                  <span
                    v-if="data.index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ options?.charge_stations?.length - 1 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.assign_to_tenant"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsCSO
                    : []
                "
                :disabled="readOnly"
                item-text="name"
                item-value="id"
                :label="'Assign to Tenant'"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            />
            <v-col
              cols="6"
              sm="4"
            >
              <v-checkbox
                v-model="options.show_on_mobile"
                :label="`Show On Mobile`"
              />
            </v-col>
            <v-col
              cols="6"
              sm="4"
            >
              <v-checkbox
                v-model="options.show_on_portal"
                :label="`Show On Portal`"
              />
            </v-col>
            <v-col
              cols="6"
              sm="4"
            >
              <v-checkbox
                v-model="options.bookable"
                :label="`Bookable`"
              />
            </v-col>
          </v-row>

          <!--  -->
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="!readOnly">{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  mixins: [validationRules],
  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      options: {
        show_on_mobile: false,
        show_on_portal: false,
        bookable: false,
        location_ids: [],
        charge_stations: [],
      },

      //
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
      //
      locationsList: "csmsChargeStations/getLocation",
      chargersList: "csmsChargeStations/getChargers",
      //
    }),
    title() {
      if (this.readOnly) {
        return "view";
      }
      if (this.type == "create") {
        return "add_new";
      } else if (this.type == "edit") {
        return "edit";
      } else {
        return "";
      }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (val) {
        if (val) {
          const params = { tenant_id: val };
          this.$store.dispatch("csmsChargeStations/LocationsList", params);
        } else {
          // this.customFilters = {};
          this.$store.commit("csmsChargeStations/SET_LOCATION", []);
          // this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
        }
      },
    },
    "options.location_ids": {
      handler: function (v) {
        if (v && v.length > 0) {
          const params = {
            tenant_id: this.options.tenant_id,
            location_ids: v,
          };
          this.$store.dispatch("csmsChargeStations/chargerList", params);
        } else {
          this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
        }
      },
    },
    // Watch for changes in the item prop, ensuring price components are updated on edit
    // type: {
    //   handler() {
    //     if (this.type === "edit") {
    //       this.updatePriceComponents();
    //     }
    //   },
    //   deep: true,  // Deep watch to ensure it reacts to any changes in the item object
    // },
  },
  async mounted() {
    if (!this.authUser.isAdmin) {
      // tenant_id is not declared in data(), so it must be added reactively
      this.$set(this.options, "tenant_id", this.authUser.tenant_id);
      this.$store.dispatch("csmsChargeStations/LocationsList", this.options);
    }

    if (this.type == "edit") {
      this.options = {
        ...this.item,
        tenant_id: this.item.owner_tenant_id,
        location_ids:
          this.item.location_ids ||
          (this.item.location_id ? [this.item.location_id] : []),
        charge_stations:
          this.item.charge_stations ||
          (this.item.charge_station_id ? [this.item.charge_station_id] : []),
      };
    }
  },
  methods: {
    onLocationChange() {
      // fires only on user selection (not on initial edit load);
      // reset chargers so they always match the chosen locations
      this.$set(this.options, "charge_stations", []);
    },
    tenantList() {
      if (this.product == "oem") {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "oem");
      } else {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "cso");
      }
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        const params = {
          ...this.options,
        };
        this.$emit("onsave", params);
      }
    },
    closeForm() {
      // this.$refs.form.reset();
      this.$emit("onclose");
    },
  },
};
</script>
<style lang="sass" scoped>
.action-btn
    cursor: pointer
    &:hover
        i
            color: #20a390
.error-row
  background-color: #fdecea

.error-message
  color: red
  font-size: 0.9em

.all-error-text
  margin-bottom: 1.5rem !important
  display: block
  margin-left: 0.65rem

.addButton
  :deep .v-btn__content
    font-size: 1.25rem !important
.priceRow
  position: relative

.deleteButton
  .action-btn
    position: absolute
    right: 30px
    top: 1px
    background: #FDEDE8
    border-radius: 6px
    padding: 0.3em 1rem
    i
      color: #FA896B

.timeField
  :deep .v-input
    flex: 1 1 0
    min-width: 0
  :deep .v-input:first-child
    margin-right: 0.75rem

.closeTime
  margin-top: 0.7rem
  cursor: pointer
</style>
